/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ResetOutlineIcon = function ResetOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3473 12.6444C18.3791 8.91061 15.3781 5.85797 11.6444 5.82612C9.66043 5.80919 7.86921 6.64753 6.61959 8.00003H9V10H3V4.00003H5V6.81005C6.62096 4.96336 9.00876 3.80356 11.6614 3.82619C16.4997 3.86747 20.3885 7.82314 20.3472 12.6614C20.3059 17.4997 16.3503 21.3885 11.512 21.3472C6.67366 21.3059 2.78491 17.3503 2.82619 12.512L4.82612 12.529C4.79426 16.2628 7.79525 19.3154 11.529 19.3473C15.2628 19.3791 18.3154 16.3781 18.3473 12.6444Z"
  }));
};
export default ResetOutlineIcon;